import { ChangeDetectionStrategy, Component, ElementRef, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { TostesStore } from 'src/app/store/tostes-store';
import { TostPositionEnum, TostTypeEnum } from 'src/app/shared/models/tostes.model';

@Component({
    selector: 'que-mini-add-logo',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './mini-add-logo.component.html',
    styleUrls: ['./mini-add-logo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MiniAddLogoComponent {
  @ViewChild('addFile') addFileInput: ElementRef | undefined;
  #questionnaireStore = inject(QuestionnaireStore)
  #tostesStore = inject(TostesStore)
  #sanitizer = inject(DomSanitizer);

  isOutOfRange = false;
  onFileSelected(event: any) {
    this.isOutOfRange = false;
    if (event.target.files) {
      const file = event.target.files[0]
      const maxSize = 100 * 1024;
      if (file.size > maxSize) {
        // File size exceeds the limit
        this.#tostesStore.addTost({guid:this.#tostesStore.generateGuid(),  message:{en:"File size exceeds the maximum allowed size (100KB)",he:"גודל הקובץ חורג מהגודל המרבי המותר (100KB)"} , position: TostPositionEnum.BottomLeft, seconds: 5, type: TostTypeEnum.ERROR })
        this.isOutOfRange = true;
        this.#questionnaireStore.updateAfterInitDefinitions();
        this.#questionnaireStore.updateLogo('');
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        var base64 = reader.result;
        this.#questionnaireStore.updateAfterInitDefinitions();
        this.#questionnaireStore.updateLogo(base64 as string);
      };
    }
  }
  logo$ = this.#questionnaireStore.logo$;

  addLogo() {
    if (this.addFileInput) {
      this.addFileInput.nativeElement.click();
    }
  }
}
